(function () {
  'use strict';

  function init() {
    var modal = document.querySelector('[data-yv-quickbuy-modal]');
    if (!modal) return;

    var els = {
    title: modal.querySelector('[data-yv-quickbuy-title]'),
    price: modal.querySelector('[data-yv-quickbuy-price]'),
    options: modal.querySelector('[data-yv-quickbuy-options]'),
    error: modal.querySelector('[data-yv-quickbuy-error]'),
    submit: modal.querySelector('[data-yv-quickbuy-submit]'),
    ctaLabel: modal.querySelector('[data-yv-quickbuy-cta-label]'),
  };

  var productCache = {};
  var activeProduct = null;
  var activeSelection = [];
  var activeVariant = null;
  var isSubmitting = false;
  var lastTrigger = null;

  var currency =
    (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency,
      }).format((cents || 0) / 100);
    } catch (e) {
      return '$' + ((cents || 0) / 100).toFixed(2);
    }
  }

  function fetchProduct(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (p) {
        productCache[handle] = p;
        return p;
      });
  }

  function findVariant(product, selection) {
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var match = true;
      for (var j = 0; j < selection.length; j++) {
        if (v.options[j] !== selection[j]) {
          match = false;
          break;
        }
      }
      if (match) return v;
    }
    return null;
  }

  function initialSelection(product) {
    var v = null;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].available) {
        v = product.variants[i];
        break;
      }
    }
    if (!v) v = product.variants[0];
    return v ? v.options.slice() : [];
  }

  function uniqueOptionValues(product, optionIndex) {
    var values = [];
    product.variants.forEach(function (v) {
      var val = v.options[optionIndex];
      if (val && values.indexOf(val) === -1) values.push(val);
    });
    return values;
  }

  function renderOptions() {
    els.options.innerHTML = '';
    if (!activeProduct) return;
    activeProduct.options.forEach(function (option, optionIndex) {
      var optionName = typeof option === 'string' ? option : (option && option.name) || '';
      var values = uniqueOptionValues(activeProduct, optionIndex);

      var row = document.createElement('fieldset');
      row.className = 'yv-quickbuy__option';

      var legend = document.createElement('legend');
      legend.className = 'yv-quickbuy__option-label';
      legend.textContent = optionName;
      row.appendChild(legend);

      var chips = document.createElement('div');
      chips.className = 'yv-quickbuy__chips';

      values.forEach(function (value) {
        var safeId =
          'yv-qb-' + optionIndex + '-' + value.replace(/[^a-z0-9]/gi, '-').toLowerCase();

        var input = document.createElement('input');
        input.type = 'radio';
        input.name = 'yv-qb-option-' + optionIndex;
        input.id = safeId;
        input.value = value;
        input.className = 'yv-quickbuy__chip-input';
        input.checked = activeSelection[optionIndex] === value;
        input.addEventListener('change', function () {
          activeSelection[optionIndex] = value;
          updateAvailability();
        });

        var label = document.createElement('label');
        label.htmlFor = safeId;
        label.className = 'yv-quickbuy__chip';
        label.textContent = value;

        chips.appendChild(input);
        chips.appendChild(label);
      });

      row.appendChild(chips);
      els.options.appendChild(row);
    });
  }

  function updateAvailability() {
    if (!activeProduct) return;
    var inputs = els.options.querySelectorAll('.yv-quickbuy__chip-input');
    inputs.forEach(function (input) {
      var optionIndex = parseInt(input.name.replace('yv-qb-option-', ''), 10);
      var trial = activeSelection.slice();
      trial[optionIndex] = input.value;
      var match = findVariant(activeProduct, trial);
      var label = els.options.querySelector('label[for="' + input.id + '"]');
      if (!label) return;
      label.classList.remove('is-unavailable', 'is-soldout');
      if (!match) {
        input.disabled = true;
        label.classList.add('is-unavailable');
      } else if (!match.available) {
        input.disabled = false;
        label.classList.add('is-soldout');
      } else {
        input.disabled = false;
      }
    });

    activeVariant = findVariant(activeProduct, activeSelection);
    updateCta();
  }

  function updateCta() {
    if (!activeVariant) {
      els.submit.disabled = true;
      els.ctaLabel.textContent = 'Unavailable';
      els.price.textContent = '';
      return;
    }
    els.price.textContent = formatMoney(activeVariant.price);
    if (!activeVariant.available) {
      els.submit.disabled = true;
      els.ctaLabel.textContent = 'Sold Out';
      return;
    }
    els.submit.disabled = isSubmitting;
    els.ctaLabel.textContent = isSubmitting ? 'Adding…' : 'Add & Checkout';
  }

  function clearError() {
    els.error.hidden = true;
    els.error.textContent = '';
  }

  function showError(msg) {
    els.error.textContent = msg;
    els.error.hidden = false;
  }

  function openModal(product, trigger) {
    activeProduct = product;
    activeSelection = initialSelection(product);
    activeVariant = findVariant(product, activeSelection);
    isSubmitting = false;
    lastTrigger = trigger || null;
    clearError();

    els.title.textContent = product.title;
    renderOptions();
    updateAvailability();

    modal.hidden = false;
    document.body.classList.add('yv-quickbuy-open');
    requestAnimationFrame(function () {
      modal.classList.add('is-open');
      var firstChip = els.options.querySelector(
        '.yv-quickbuy__chip-input:not([disabled])'
      );
      try {
        (firstChip || els.submit).focus();
      } catch (e) {}
    });
  }

  function closeModal() {
    if (modal.hidden) return;
    modal.classList.remove('is-open');
    setTimeout(function () {
      modal.hidden = true;
      document.body.classList.remove('yv-quickbuy-open');
      activeProduct = null;
      activeVariant = null;
      activeSelection = [];
      isSubmitting = false;
      els.options.innerHTML = '';
      clearError();
      if (lastTrigger) {
        try {
          lastTrigger.focus();
        } catch (e) {}
        lastTrigger = null;
      }
    }, 180);
  }

  function addToCartAndCheckout(variantId) {
    isSubmitting = true;
    updateCta();
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then(function (r) {
        return r.json().then(function (data) {
          return { ok: r.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          isSubmitting = false;
          showError(
            (result.data && (result.data.description || result.data.message)) ||
              'Could not add to cart.'
          );
          updateCta();
          return;
        }
        window.location.href = '/checkout';
      })
      .catch(function () {
        isSubmitting = false;
        showError('Network error — please try again.');
        updateCta();
      });
  }

  // Capture-phase: intercept before the parent <a> navigates.
  document.addEventListener(
    'click',
    function (e) {
      var trigger = e.target.closest && e.target.closest('[data-yv-quickbuy]');
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();

      var handle = trigger.getAttribute('data-product-handle');
      if (!handle) return;

      fetchProduct(handle)
        .then(function (product) {
          // Single-variant: skip modal — go straight to checkout if available.
          if (product.variants.length === 1) {
            if (!product.variants[0].available) {
              openModal(product, trigger);
              return;
            }
            addToCartAndCheckout(product.variants[0].id);
            return;
          }
          openModal(product, trigger);
        })
        .catch(function () {
          // Fallback to PDP if product JSON fails to load.
          var link = trigger.closest('a');
          if (link && link.href) window.location.href = link.href;
        });
    },
    true
  );

  els.submit.addEventListener('click', function () {
    if (!activeVariant || !activeVariant.available || isSubmitting) return;
    clearError();
    addToCartAndCheckout(activeVariant.id);
  });

  modal.querySelectorAll('[data-yv-quickbuy-close]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      closeModal();
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) closeModal();
  });
  } // end init

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
